import Dialog from '../Dialog/Dialog'
import { message, Tabs } from 'ant-design-vue'
// import { RoleInfo, SearchRoleStudio, SearchRolePlayTime, SearchRoleVideo, SearchStreamerInfo, SearchRoleAssistant, SearchIntimacyList, RechargeAction } from '../../views/game/game_role/modules/'

export default function GameRoleInfo(showId) {
  if (isNaN(parseInt(showId))) {
    message.error('角色Id错误')
    return
  }

  return Dialog({
    content: (
      <div>
        <Tabs>
          {/* <Tabs.TabPane key={1} tab={"基本信息"}>
                    <RoleInfo showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={2} tab={"主播信息"}>
                    <SearchStreamerInfo showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={3} tab={"游戏时长"}>
                    <SearchRolePlayTime showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={4} tab={"直播间信息"}>
                    <SearchRoleStudio showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={5} tab={"助理信息"}>
                    <SearchRoleAssistant showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={6} tab={"亲密关系"}>
                    <SearchIntimacyList showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={7} tab={"短视频信息"}>
                    <SearchRoleVideo showId={parseInt(showId)} />
                </Tabs.TabPane>
                <Tabs.TabPane key={8} tab={"充值行为"}>
                    <RechargeAction showId={parseInt(showId)} />
                </Tabs.TabPane> */}
        </Tabs>
      </div>
    ),
  })
}
